import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { getMessage } from '@/helpers/utils';
import { Snackbar } from '@scramble/ui';
import { cashService } from '../../services/cashService';

export const useUpdateBankAccount = id => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      cashService
        .updateBankAccount(id, payload)
        .then(response => {
          const { status, data } = response;
          const message = getMessage(data);
          if (status === 200) {
            queryClient.invalidateQueries({
              queryKey: [QUERY_KEYS.cash.bank_accounts],
            });
            queryClient.setQueryData(
              [QUERY_KEYS.cash.bank_account_detail, id],
              () => data,
            );
            return data;
          }

          if (status === 406) {
            Snackbar({
              type: 'danger',
              text: getMessage(data),
            });
          }

          throw new Error(data?.message || message);
        })
  });
};
